<template>
  <AppModal :model-value="state.open" :title="state.title" size="sm" @close="answer(false)">
    <p v-if="state.message" class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">{{ state.message }}</p>
    <template #footer>
      <AppButton variant="outline" @click="answer(false)">Annuler</AppButton>
      <AppButton :variant="state.danger ? 'danger' : 'primary'" @click="answer(true)">{{ state.confirmLabel }}</AppButton>
    </template>
  </AppModal>
</template>

<script>
import AppModal from './AppModal.vue'
import AppButton from './AppButton.vue'
import { confirmState, answerConfirm } from '@/stores/confirm'

export default {
  name: 'ConfirmDialog',
  components: { AppModal, AppButton },
  setup() {
    return { state: confirmState, answer: answerConfirm }
  }
}
</script>
